import { EyeOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import style from './style.module.css';

interface ITcDetailIcon {
  onClick?: () => void;
  to?: string;
  tooltip?: string;
  blank?: boolean;
  placement?: 'right' | 'top';
}

const TcDetailIcon: FC<ITcDetailIcon> = ({ onClick, to, tooltip, blank = true, placement = 'top' }) => {
  if (onClick)
    return (
      <span className={`inline ${style['green-icon']}`}>
        <Tooltip title={tooltip ? tooltip : 'جزئیات'} placement={placement}>
          <EyeOutlined onClick={onClick} className='mx-[5px] text-t-primary-color inline-block' />
        </Tooltip>
      </span>
    );

  return (
    <span className={`inline ${style['green-icon']}`}>
      <Link to={to || ''} target={blank ? '_blank' : '_self'}>
        <Tooltip title={tooltip ? tooltip : 'جزئیات'} placement={placement}>
          <EyeOutlined className='mx-[5px] text-t-primary-color inline-block' />
        </Tooltip>
      </Link>
    </span>
  );
};

export default memo(TcDetailIcon);
